export default {
  methods: {
    toggleDrawer ({ name }) {
      return this.$store.dispatch('drawers/toggle', { name })
    }
  }
}
